import React, {useState, useEffect, useContext, useRef} from "react";
import {store} from '../../context/store';
import {functions} from "../../constants/common-functions";
import {useHistory} from 'react-router-dom';
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {GREY_BACKGROUND} from "../../constants/general-constants";
import homebanner from "../../../images/laserbackground.jpg";
import HomeBoxLeases from "../../pages/home/components/HomeBoxLeases";
import TopBarChart from "../../components/TopBarChart";
import RealEstateWaterfall from "../dashboardlease/components/RealEstateWaterfall";
import RealEstateLeasesByLandlord from "../dashboardlease/components/RealEstateLeasesByLandlord";
import RealEstateSavingOpportunities from "../dashboardlease/components/RealEstateSavingOpportunities";
import RealEstateLeasesTopTwenty from "../dashboardlease/components/RealEstateLeasesTopTwenty";
import RealEstateTimeline from "../dashboardlease/components/RealEstateTimeline";
import {PURPLE} from "../../constants/general-constants";
import backgroundImage from "../../../images/nationwidebackground.png";

export default function DashboardLease(){
	
  
  const thisContainer = {
  	display:"flex",
  	position:"fixed",
  	flexDirection:"column",
  	width:"100%",
  	height:"100vh",
  	left:"0px",
  	top:"0px",
  	backgroundColor:GREY_BACKGROUND
  };
  
  const mainContainer = {
  	display:"flex",
  	position:"fixed",
  	width:"calc(100% - 60px)",
  	height:"calc(100vh - 60px)",
  	left:"60px",
  	top:"60px"
  };
  
  const leftContainer = {
  	display:"flex",
  	width:"400px",
  	height:"100%",
  	flexDirection:"column",
  	//backgroundImage:"url(" + homebanner + ")",
  	//backgroundSize:"auto 100%",
  	//backgroundColor:'#011546',
  	background:"url(" + backgroundImage + ")",
  	backgroundSize:"100% 100%"
  };
  
  const contentBox = {
		display:"flex",
		width:"100%",
		//backgroundColor:"rgba(0,0,0,0.6)",
		minHeight:"calc(100% - 20px)",
		borderRadius:"10px",
		color:"white",
		fontSize:"12px",
		flexDirection:"column",
		borderLeft:"0px solid black"
	};
	
	const chartContainer = {
		display:"flex",
		width:"calc(100% - 60px)",
		margin:"30px",
		marginTop:"40px"
	};
	
	const topData = [
		{category:'London HQ', percentage:'98%', label:'210K'},
		{category:'Swindon HQ', percentage:'88%', label:'190K'},
		{category:'Training Campus', percentage:'88%', label:'181K'},
		{category:'Data Warehouse', percentage:'68%', label:'107K'},
		{category:'Conference Venue', percentage:'38%', label:'65K'},
	];
	
	const dashboard = {
		display:"flex",
		width:"calc(100% - 410px)",
		overflow:"auto",
		padding:"10px",
		flexWrap:"wrap"
	};
	
	const dashboardComponent = {
		display:"flex",
		backgroundColor:"white",
		width:"calc(50% - 20px)",
		margin:"10px",
		backgroundColor:"white",
		borderRadius:"6px",
		flexDirection:"column"
	};
	
	const componentTitle = {
		display:'flex',
		width:"calc(100% - 0px)",
		height:"40px",
		alignItems:"center",
		fontSize:"14px",
		justifyContent:"space-around",
		borderBottom:"2px solid #759EFF"
	};
	
	const dashboardTitle = {
		display:'flex',
		width:"100%",
		minHeight:"100px",
		alignItems:"center",
		justifyContent:"space-around",
		fontSize:"36px",
		color:"white"
	};
	
	return (
			<div style={thisContainer}>
				<Header/>
				<LeftMenu/>
				<div style={mainContainer}>
					<div style={leftContainer}>
						<div style={contentBox}>
							<div style={dashboardTitle}>
								Lease Analysis
							</div>
							<HomeBoxLeases/>
							<div style={chartContainer}>
								<TopBarChart
									title="Top Properties Sq Ft"
									data={topData}
								/>
							</div>
						</div>
					</div>
					<div style={dashboard}>
						<div style={dashboardComponent}>
							<div style={componentTitle}>
								Potential Portfolio Reduction
							</div>	
							<RealEstateWaterfall/>
						</div>
						<div style={dashboardComponent}>
								<div style={componentTitle}>
									Leases By Landlord
								</div>	
								<RealEstateLeasesByLandlord/>
						</div>
						<div style={dashboardComponent}>
							<div style={componentTitle}>
								Saving Opportunities
							</div>	
							<RealEstateSavingOpportunities/>
						</div>
						<div style={dashboardComponent}>
								<div style={componentTitle}>
									Top Twenty By Leased Area
								</div>	
								<RealEstateLeasesTopTwenty/>
						</div>
						<div style={{...dashboardComponent, width:'calc(100% - 20px)'}}>
								<div style={componentTitle}>
									Timeline
								</div>	
								<RealEstateTimeline/>
						</div>
					</div>
				</div>
			</div>
	);
}